function stickProductDetailsToTop() {
    let window_top = $(window).scrollTop()
    let top = $('.nav-magnet').offset().top - 126

    if (window_top > top) {
        $('body').addClass('shrink-nav')
        $('.product-info-nav').addClass('stick')
        $('.nav-magnet').addClass('active')
        // $('.nav-magnet').height($('.product-info-nav').outerHeight())
    } else {
        $('body').removeClass('shrink-nav')
        $('.product-info-nav').removeClass('stick')
        $('.nav-magnet').removeClass('active')
    }
}

Garnish.$doc.ready(function () {

    // Sticking product details nav to the top
    // TODO: add a check if this needs to happen
    $(window).scroll(stickProductDetailsToTop)
    stickProductDetailsToTop()

    // Scroll to product detailed section
    $('.section-navigation').on('click', function (e) {
        e.preventDefault()
        $('.section-navigation').removeClass('active')
        let target = $(this).attr('href')
        $(this).addClass('active')
        $('.mobile-current-nav-item').find('.text').html($(this).text())

        $('html, body').animate({
            scrollTop: $(target).offset().top - 50
        }, 700)
    })


    // Product Information Waypoints : Using in-view now
    inView.threshold(0.3)
    inView('.tabbed-section')
        .on('enter', el => {
            let targetId = $(el).data('target')
            let title = $(el).data('title')
            $('.section-navigation').removeClass('active')
            $('#nav-' + targetId).addClass('active')
            $('.mobile-current-nav-item').find('.text').html(title)
        })
        .on('exit', el => {
        })

    let piNavigationItems = []
    $.each($('.tabbed-section'), function (i, el) {

    })

    // Product Image Zoom
    // $('[data-image-zoom-wrapper]').each(function (i, el) {
    //     let zoomUrl = $(this).data('zoom')
    //     $(this).zoom({
    //         url: zoomUrl
    //     })
    // });

    // Setup & Care
    $('#setup-care-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        adaptiveHeight: true,
        cssEase: 'cubic-bezier(1, 0.19, 0.25, 1)',
        prevArrow: '<button type="button" class="slick-brand-prev"><svg width="29" height="13" xmlns="http://www.w3.org/2000/svg"><g fill="#000" fill-rule="nonzero"><path d="M0 6.5L11 0v13z"/><path d="M29 5v3H8V5z"/></g></svg></button>',
        nextArrow: '<button type="button" class="slick-brand-next"><svg width="29" height="13" xmlns="http://www.w3.org/2000/svg"><g fill="#000" fill-rule="evenodd"><path d="M29 6.5L18 13V0z"/><path fill-rule="nonzero" d="M21 5v3H0V5z"/></g></svg></button>',
    })

    $('.play-video').on('click', function () {
        $(this).parent().find('.video-container').addClass('active')
    })

    // Product Class
    window.ProductPage = new SP.ProductPage('.template-product')

    // new Shopify.OptionSelectors('product-select', { product: 32400816308268, onVariantSelected: function(variant) {
    //         console.log('variant: ', variant)
    //     }})
})

// (function() {
//     let pplr_custom_form_add = function() {
//         console.log('hi')
//     }
// })();

//
// FLD.prototype.init = function () {
//     initFld.apply(this, arguments)
//     new TabEditor(this)
//     this.tabGrid.refreshCols(true)
// }

